module.exports = __webpack_public_path__ + "static/media/mosiac1.ee31f858.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/05/projects/01/mosiac1.png
// module id = 414
// module chunks = 0